import { useEffect } from "react";

import setLocation from "shared/setLocation";
import SpaceliftLoader from "components/loading/PageLoading";
import useTitle from "hooks/useTitle";

const LoginOauth2 = () => {
  useTitle("Redirecting to OAuth2 endpoint...");

  useEffect(() => {
    setLocation(`/oauth2/authorize${window?.location.search}`);
  }, []);

  return <SpaceliftLoader />;
};

export default LoginOauth2;
